import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative font-montserrat" }
const _hoisted_2 = { class: "overflow-auto h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalHistoryCourier = _resolveComponent("ModalHistoryCourier")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_TableV2, {
          loading: _ctx.listData.loading,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.listData.data,
          isEmpty: _ctx.isEmptyList,
          emptyHeaderMessage: _ctx.$t('courierManagement.emptyApprovalHeader'),
          emptyMessage: _ctx.$t('courierManagement.emptyApprovalMessage'),
          class: "my-2",
          isDetailAble: _ctx.isDetailAble,
          pagination: _ctx.listData.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listData.pagination = $event)),
          paginationStyle: "v1",
          iconColor: "green-lp-100",
          groupAction: true,
          groupOptions: _ctx.actionGroupOptions,
          onRequest: _ctx.fetchList,
          onTryAgain: _ctx.fetchList
        }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "emptyMessage", "isDetailAble", "pagination", "groupOptions", "onRequest", "onTryAgain"])
      ])
    ]),
    (_ctx.isOpenModalApproval)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: () => _ctx.onClose('approval'),
          onSubmit: _ctx.onSubmitApprove,
          textSuccess: _ctx.$t('courierManagement.accept'),
          textCancel: _ctx.$t('courierManagement.back'),
          title: _ctx.$t('courierManagement.acceptRequest'),
          message: _ctx.$t('courierManagement.acceptRequestMessage'),
          image: "badge-confirmation-general"
        }, null, 8, ["onClose", "onSubmit", "textSuccess", "textCancel", "title", "message"]))
      : _createCommentVNode("", true),
    (_ctx.isOpenModalRejected)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: () => _ctx.onClose('rejected'),
          onSubmit: _ctx.onSubmitReject,
          textSuccess: _ctx.$t('courierManagement.reject'),
          textCancel: _ctx.$t('courierManagement.back'),
          title: _ctx.$t('courierManagement.rejectRequest'),
          message: _ctx.$t('courierManagement.rejectRequestMessage'),
          image: "badge-confirmation-general"
        }, null, 8, ["onClose", "onSubmit", "textSuccess", "textCancel", "title", "message"]))
      : _createCommentVNode("", true),
    (_ctx.isOpenModalSuccess)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onSubmit: _ctx.onConfirmSuccess,
          textSuccess: _ctx.$t('courierManagement.okGotIt'),
          title: 
      _ctx.$t('courierManagement.requestSuccess', {
        action:
          _ctx.actionType === 'REJECT'
            ? _ctx.$t('courierManagement.requestRejected')
            : _ctx.$t('courierManagement.requestAccepted')
      })
    ,
          image: "badge-success"
        }, null, 8, ["onSubmit", "textSuccess", "title"]))
      : _createCommentVNode("", true),
    (_ctx.historyCourierModal)
      ? (_openBlock(), _createBlock(_component_ModalHistoryCourier, {
          key: 3,
          modelValue: _ctx.historyCourierModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.historyCourierModal = $event)),
          onCloseModal: _ctx.onCloseModalHistory,
          dataHistory: _ctx.listHistoryCourierData
        }, null, 8, ["modelValue", "onCloseModal", "dataHistory"]))
      : _createCommentVNode("", true)
  ], 64))
}